import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { FC } from 'react'
import { AvalaraSalesTaxSettings } from 'SettingsV2/components/tax-rates/avalara/AvalaraSalesTaxSettings'
import { NumeralSalesTaxSettings } from 'SettingsV2/components/tax-rates/numeral/NumeralSalesTaxSettings'
import { AnrokSalesTaxSettings } from 'SettingsV2/components/tax-rates/anrok/AnrokSalesTaxSettings'

import { SalesTaxSettings } from 'SettingsV2/components/tax-rates/SalesTaxSettings'

export const SalesTaxSettingsPage: FC = () => {
  const result = useQuery(dashboardv99990101Client.getEnabledTaxIntegration)

  const taxProvider = result.data?.taxIntegrationProvider?.toUpperCase()
  if (taxProvider === 'AVALARA') {
    return <AvalaraSalesTaxSettings />
  }

  if (taxProvider === 'NUMERAL') {
    return <NumeralSalesTaxSettings />
  }

  if (taxProvider === 'ANROK') {
    return <AnrokSalesTaxSettings />
  }

  return <SalesTaxSettings />
}
